import Vue from 'vue';
import axios from 'axios';

// Set the base URL for your API
axios.defaults.baseURL = process.env.VUE_APP_BASE_URL;

Vue.prototype.$axios = axios;